var $31c38256782f7888$exports = {};
$31c38256782f7888$exports = {
    "actions": `Akcie`,
    "hideButtonLabel": `Zobrazi\u{165} menej`,
    "noTags": `\u{17D}iadne`,
    "showAllButtonLabel": (args, formatter)=>`Zobrazi\u{165} v\u{161}etko (${formatter.number(args.tagCount)})`
};


export {$31c38256782f7888$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
